<script lang="ts">
    import type {ThreadMessage} from 'src/features/threads/types';
    import {exists, ignoreUnusedProperties} from 'shared/utils/custom-utils';
    import {popInAnim} from 'shared/animations/pop-animations';
    import ThreadMessageBubble from 'src/features/threads/shared-components/ThreadMessageBubble.svelte';
    import MessageComposerBar from 'src/features/threads/shared-components/MessageComposerBar.svelte';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';

    export let placement: 'fullscreen-page' | 'popover';

    const messages = [];

    const handleMessageSent = (event: CustomEvent<string>) => {
        // TODO: Implement message sending
        ignoreUnusedProperties(event);

        /*
        tick().then(() => {
            const lastMessageElement = document.getElementById(`message-${newMessage.id}`);
            lastMessageElement?.scrollIntoView({behavior: 'smooth'});
        });
        */
    };

    function shouldShowMessageHeader(message: ThreadMessage) {
        const index = messages.indexOf(message);
        const beforeMessage = messages[index + 1];

        if (!exists(beforeMessage)) {
            return true;
        }

        if (beforeMessage.sender.id !== message.sender.id) {
            return true;
        }

        const currentDate = message.sentAt;
        const beforeDate = beforeMessage.sentAt;

        if (currentDate.getDate() !== beforeDate.getDate() ||
            currentDate.getMonth() !== beforeDate.getMonth() ||
            currentDate.getFullYear() !== beforeDate.getFullYear()) {
            return true;
        }

        return beforeDate.getHours() !== currentDate.getHours();
    }
</script>

<div class="thread-content"
     class:in-fullscreen-page="{placement === 'fullscreen-page'}"
     class:in-popover="{placement === 'popover'}">

    <div class="messages-container">
        {#each messages as message(message.id)}
            <!-- TODO: Check if the message is self-sent message -->
            {@const selfMessage = false}

            <div class="message-anim-container"
                 id="message-{message.id}"
                 class:self-message="{selfMessage}"
                 class:other-message="{!selfMessage}"
                 in:popInAnim={{key: `message-${message.id}`}}>

                <ThreadMessageBubble {message} withoutHeader="{!shouldShowMessageHeader(message)}"/>
            </div>
        {/each}

        {#if messages.length === 0}
            <div class="no-messages-container">
                <IconedContent icon="message-slash" orientation="vertical" align="center" justify="center">
                    V tomto vlákně zatím nebyly odeslány žádné zprávy
                </IconedContent>
            </div>
        {/if}
    </div>

    <div class="thread-content-input">
        <MessageComposerBar threadContentPlacement="{placement}" on:message-sent={handleMessageSent}/>
    </div>
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";
    @import (reference) "styles/portaro-erp.less";

    .thread-content {
        display: flex;
        flex-direction: column;
        flex: 1 1 0;

        &.in-fullscreen-page {
            .thread-content-input {
                padding: 0 @main-padding-horizontal @main-padding-vertical;
            }

            .messages-container {
                padding: @main-padding-vertical @main-padding-horizontal @spacing-xxl;
            }
        }

        &.in-popover {
            .thread-content-input {
                padding: @spacing-ml;
                border-top: 1px solid @themed-border-default;
            }

            .messages-container {
                padding: @spacing-ml;
            }
        }

        .messages-container {
            .flex-grow();
            flex-direction: column-reverse;
            gap: @spacing-sm;
            overflow-y: auto;

            .message-anim-container {
                &.self-message {
                    align-self: flex-end;
                }

                &.other-message {
                    align-self: flex-start;
                }
            }
        }

        .no-messages-container {
            .flex-grow();
            align-items: center;
            justify-content: center;
        }
    }
</style>